import { useLocaleData, useT } from "../../i18n/useT";
import LanguageSwitcher from "./LanguageSwitcher";
import { Link } from "react-router-dom";
import React from "react";
import ThemeSwitcher from "./ThemeSwitcher";
import { useLocale } from "../../i18n/LocaleProvider";

// eslint-disable-next-line no-undef
const PUBLIC_URL = process.env.PUBLIC_URL || "";

const Navigation = () => {
  const t = useT();
  const { lang } = useLocale();
  const brand = useLocaleData("header.displayName") || "Vladimir Egay";
  const sectionHref = (id) => `${PUBLIC_URL}/${lang}#${id}`;
  return (
    <nav className="navbar navbar-expand-lg fixed-top justify-content-between px-4 bg-theme-nav">
      <Link to={`/${lang}`} className="navbar-brand">
        {brand}
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("about")}>
              {t("nav.about")}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("education")}>
              {t("nav.education")}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("experience")}>
              {t("nav.experience")}
            </a>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`/${lang}/projects`}>
              {t("nav.projects")}
            </Link>
          </li>
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("skills")}>
              {t("nav.skills")}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("certificates")}>
              {t("nav.certificates")}
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href={sectionHref("interests")}>
              {t("nav.interests")}
            </a>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`/${lang}/blog`}>
              {t("nav.blog")}
            </Link>
          </li>
        </ul>
        <div className="ms-3 d-flex align-items-center gap-2">
          <LanguageSwitcher />
          <ThemeSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
